'use strict';
import {ngDepModel} from './ngdepmodel.js';

export class konkursasModel extends ngDepModel {
    constructor(itemData, $filter, jsDataService){
        super(itemData, $filter, jsDataService);
        this.setupItemData(itemData);
    }

    getValue(name){
        switch(name){
            case 'date':
            case 'created':
            case 'updated':
                if (!this.date || this.date == 0) return '';
                return this.s('$filter')('u2date')(this.date, 'yyyy-MM-dd');

            case 'terminas':
                if (!this.terminas || this.terminas == 0) return '';
                return this.s('$filter')('u2date')(this.terminas, 'yyyy-MM-dd');

            case 'institucija_title':
                return this.institucija_title || '';

            case 'mkryptis_title':
                return this.mkryptis_title || '';

            case 'pareigos':
                return this.pareigos || '';

            case 'padalinys':
                return this.padalinys || '';

            case 'active':
                return typeof this.active !== 'undefined' ? this.active : '';

            default:
                if (typeof this[name] !== 'undefined' && this[name] !== '') return this[name];
                return '';
        }
    }
}
